import { useState } from "react";
import { ASSET_PATHS } from "./assets";
import { Link } from "react-router-dom";

export const FAQItem = ({ question, id }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-y border-gray-200/30">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex flex-row justify-between items-center w-full p-5 md:p-6 text-left hover:bg-white/5 transition-colors"
        aria-expanded={isOpen}
        aria-controls={`faq-answer-${id}`}
      >
        <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl">{question}</span>
        <img
          className={`w-5 h-5 md:w-6 md:h-6 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
          src={ASSET_PATHS.buttons.dropDown}
          alt="Dropdown icon"
        />
      </button>
      {isOpen && (
        <div id={`faq-answer-${id}`} className="p-5 md:p-6 pt-0 font-kodeMono text-gray-400 text-sm sm:text-base md:text-lg">
          This is a placeholder answer. Replace with actual content for "{question}". 
          CaptchaSonic stands out due to its advanced AI, unparalleled speed, robust security, and developer-friendly integration options.
        </div>
      )}
    </div>
  );
};

export const FAQSection = () => {
  const faqs = [
    "What makes your services stand out from the crowd?",
    "How secure is CaptchaSonic?",
    "What types of CAPTCHAs can CaptchaSonic solve?",
    "Is there a free trial or beta program?",
    "How do I integrate CaptchaSonic into my application?",
    "What are the pricing plans for CaptchaSonic?",
  ];
  return (
    <div className="bg-gradient-to-bl from-[#130236] to-[#000000] text-gray-300 font-kodeMono">
      <div className="container mx-auto px-4 py-8 md:py-6">
        {/* MODIFICATION: Added `relative` to this container to position the badge */}
        <div className="relative w-full max-w-4xl lg:w-[64rem] mx-auto text-center md:text-left">
          <h2 className="font-pixel text-4xl sm:text-5xl md:text-6xl text-white mb-3 md:mb-4">
            "Curious Minds, <br className="hidden md:inline" /> Answered Here!"
          </h2>
          <p className="py-2 md:py-4 text-base sm:text-lg md:text-xl text-gray-400">
            Got Questions? We’ve Got Answers!
          </p>
          
          {/* --- NEW: EYE-APPEALING CYBERPUNK BADGE --- */}
          <Link
            to="/faq" // Change this to your actual FAQ page route
            className="group absolute top-0 right-0"
          >
            <div
              className="relative transition-all duration-300 ease-in-out group-hover:-translate-y-1"
              // This is the outer container that creates the gradient border
              style={{
                clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%)",
                padding: '1.5px', // This controls the border thickness
                backgroundImage: 'linear-gradient(to right, #06b6d4, #4f46e5)', // cyan-500 to indigo-600
                boxShadow: '0 0 15px rgba(59, 130, 246, 0.3)',
              }}
            >
              <div 
                // This is the inner container with the dark background
                className="flex items-center gap-3 px-4 py-1.5 bg-black/80 backdrop-blur-sm transition-all duration-300 ease-in-out group-hover:bg-black/60"
                style={{
                  clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%)",
                }}
              >
                <span className="font-kodeMono text-xl font-bold text-cyan-300 transition-colors duration-300 group-hover:text-white">
                  VIEW ALL
                </span>
                <span className="font-bold text-cyan-400 transition-transform duration-300 group-hover:text-white group-hover:translate-x-1">
                </span>
              </div>
            </div>
          </Link>
          {/* --- END OF NEW BADGE --- */}

        </div>
        <div className="w-full max-w-4xl lg:w-[64rem] mx-auto mt-8 md:mt-12 space-y-4 md:space-y-6">
          {faqs.map((faq, index) => (
            <FAQItem key={index} question={faq} id={index + 1}/>
          ))}
        </div>
      </div>
      <div className="relative flex flex-col md:flex-row items-center justify-center h-[40rem] sm:h-[48rem] md:h-[60rem] lg:h-[70rem] overflow-hidden px-4 gap-8">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(59,130,246,0.15),_transparent_60%)] blur-2xl" />
        
        {/* CORRECTED IMAGE: Now perfectly centered */}
        <img
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                     w-[50rem] h-[60rem]        
                     sm:w-[60rem] sm:h-[60rem]  
                     md:w-[110rem] md:h-[100rem] 
                     max-w-none max-h-none 
                     object-cover
                     opacity-30 md:opacity-40 
                     transform scale-x-[-1]"
          src={ASSET_PATHS.sonicImage}
          alt="sonic logo"
        />
        </div>
      </div>
  );
};
